import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Row, Col, Card, CardHeader, CardBody, Alert, Label } from "reactstrap";
import { DataTable, TableRowField, ExportCSV } from "../../../../components";
import { getDaysBalance } from "../../../../store/report/actions";
import { layout, roles, messages } from "../../../../common/constants";
import MediaQuery from "react-responsive";
import { formatHelper } from "../../../../common/helpers";
import "react-dates/initialize";
import { DateRangePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import { getDaysBalance as daysBalanceExport } from "../../../../service/report";

import { getStores } from "../../../../store/store/actions";
import { selectUserRole } from "../../../../store/user/selector";
import { selectStoresForSelect } from "../../../../store/store/selector";
import Select from "react-select";
import { exportExcel } from "./excel";

class DaysBalance extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: null,
      endDate: null,
      focusedInput: null,
      page: 1,
      loadingExport: false,
      selectedStore: null,
    };
    this.handleObtainReportExport = this.handleObtainReportExport.bind(this);

    this.handlePageChange = this.handlePageChange.bind(this);

    this.handleStoreChange = this.handleStoreChange.bind(this);
  }

  async handleStoreChange(value) {
    if (value == this.state.selectedStore) return;
    await this.setState({ selectedStore: value, page: 1 });

    if (
      this.state.startDate &&
      this.state.endDate &&
      this.state.selectedStore
    ) {
      this.props.getDaysBalance({
        page: this.state.pageDetails,
        startDate: this.state.startDate._d,
        endDate: this.state.endDate._d,
        store: this.state.selectedStore.value,
      });
    }
  }

  async componentDidMount() {
    await this.props.getStores({ reset: true });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.stores.length == 0 && this.props.stores.length > 0) {
      this.setState({ selectedStore: this.props.stores[0] });
    }
  }

  handleDayBalanceDateChange(startDate, endDate) {
    this.setState({ startDate, endDate });

    if (startDate != null && endDate != null) {
      this.props.getDaysBalance({
        page: this.state.page,
        startDate: startDate._d,
        endDate: endDate._d,
        store: this.state.selectedStore.value,
      });
    }
  }

  performGetDaysBalance(reset = false) {
    const { getDaysBalance } = this.props;
    const { page } = this.state;

    getDaysBalance({
      page,
      startDate: this.state.startDate._d,
      endDate: this.state.endDate._d,
      store: this.state.selectedStore.value,
      reset,
    });
  }

  async handlePageChange(page) {
    await this.setState({ page: page });
    this.performGetDaysBalance();
  }
  renderDataTable(columns) {
    return (
      <DataTable
        data={this.props.daysBalance}
        keyField="created_at"
        columns={columns}
        page={this.state.page}
        totalSize={this.props.total}
        sizePerPage={this.props.pageSize}
        loading={this.props.loading}
        onPageChange={this.handlePageChange}
      />
    );
  }

  handleObtainReportExport() {
    this.setState({ loadingExport: true });
    const { startDate, endDate, selectedStore } = this.state;
    daysBalanceExport(0, startDate._d, endDate._d, selectedStore.value)
      .then((response) => {
        exportExcel(response.data.data, selectedStore, startDate, endDate);
      })
      .finally(() => {
        this.setState({ loadingExport: false });
      });
  }

  render() {
    const columnsXS = [
      {
        dataField: "xs",
        text: "Balance por Día",
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField label="Fecha:" value={row.created_at} />
              <TableRowField label="Cantidad:" value={row.count} />
              <TableRowField
                label="Total (S/):"
                value={formatHelper.toMoney(row.total)}
              />
            </div>
          );
        },
      },
    ];
    const columnsSM = [
      {
        dataField: "xs",
        text: "Balance por Dia",
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField label="Fecha:" value={row.created_at} />
              <TableRowField label="Cantidad:" value={row.count} />
              <TableRowField
                label="Total (S/):"
                value={formatHelper.toMoney(row.total)}
              />
            </div>
          );
        },
      },
    ];
    const columnsMD = [
      {
        dataField: "created_at",
        text: "Fecha",
      },
      {
        dataField: "count",
        text: "Cantidad",
      },
      {
        dataField: "total",
        text: "Total (S/)",
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField label="" value={formatHelper.toMoney(row.total)} />
            </div>
          );
        },
      },
    ];
    const { startDate, endDate } = this.state;

    return (
      <div>
        <Card>
          <CardHeader>
            <i className="icon-chart"></i>Balance por Dias
          </CardHeader>
          <CardBody>
            {(this.props.role == roles.SUPER_ADMIN ||
              this.props.role == roles.ADMIN) && (
              <Row className="my-4">
                <Col sm="1">
                  <Label className="mt-2">Tienda:</Label>
                </Col>

                <Col sm="4">
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    isLoading={this.props.loadingStores}
                    isSearchable={true}
                    noOptionsMessage={() => {
                      return messages.SELECT_NO_OPTIONS;
                    }}
                    placeholder=""
                    options={this.props.stores}
                    loadingMessage={() => {
                      return messages.SELECT_LOADING;
                    }}
                    onChange={this.handleStoreChange}
                    value={this.state.selectedStore}
                    isDisabled={this.props.loadingStores || this.props.loading}
                  />
                </Col>
              </Row>
            )}
            <Row className="mb-2">
              <Col sm="8">
                <DateRangePicker
                  startDate={startDate}
                  startDateId="startDate"
                  endDate={endDate}
                  endDateId="endDate"
                  displayFormat={"DD/MM/YYYY"}
                  disabled={this.props.loadingStores || this.props.loading}
                  onDatesChange={({ startDate, endDate }) =>
                    this.handleDayBalanceDateChange(startDate, endDate)
                  }
                  focusedInput={this.state.focusedInput}
                  onFocusChange={(focusedInput) =>
                    this.setState({ focusedInput })
                  }
                  startDatePlaceholderText="Fecha Inicio"
                  endDatePlaceholderText="Fecha Fin"
                  small
                  isOutsideRange={() => false}
                  hideKeyboardShortcutsPanel
                  minimumNights={0}
                />
              </Col>
              <Col sm="4">
                {this.state.startDate && this.state.endDate ? (
                  <ExportCSV
                    disabled={this.state.loadingExport}
                    exportCSV={this.handleObtainReportExport}
                  />
                ) : null}
              </Col>
            </Row>
            <hr className="my-4" />
            {startDate != null && endDate != null ? (
              <Row>
                <Col>
                  <Row className="mb-2">
                    <Col>
                      <b>Total de Ventas (S/):</b>{" "}
                      {formatHelper.toMoney(this.props.totalBought)}
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                        {this.renderDataTable(columnsXS)}
                      </MediaQuery>
                      <MediaQuery
                        minWidth={layout.SM_MIN_WIDTH}
                        maxWidth={layout.MD_MAX_WIDTH}
                      >
                        {this.renderDataTable(columnsSM)}
                      </MediaQuery>
                      <MediaQuery minWidth={layout.LG_MIN_WIDTH}>
                        {this.renderDataTable(columnsMD)}
                      </MediaQuery>
                    </Col>
                  </Row>
                </Col>
              </Row>
            ) : (
              <Row>
                <Col>
                  <Alert color="info">
                    Seleccione un rango de fechas para visualizar los datos
                  </Alert>
                </Col>
              </Row>
            )}
          </CardBody>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { daysBalance, totalBought, total, pageSize, error, loading } =
    state.report.daysBalanceList;

  return {
    daysBalance,
    totalBought,
    total,
    pageSize,
    error,
    loading,

    role: selectUserRole(state),
    stores: selectStoresForSelect(state),
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getDaysBalance,
      getStores,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(DaysBalance);



// WEBPACK FOOTER //
// ./src/scenes/Report/Balance/DaysBalance/DaysBalance.js